import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddIcon from "@mui/icons-material/Add";
import {
  Card,
  CardMedia,
  Divider,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import Select from "../../../../components/Select/Select";
import { soapApiJson } from "../../../../redux/actions/api";
import {
  clinicReassignAppointment,
  clinicRescheduleAppointment,
  getAppointmentsByVetIdAndDate,
  getAvailabilityByVetIdAndType,
  getInpatientAlertsByAppointmentIdWoLoader,
  postClinicalNotesWoLoader,
  setApiInProgress,
  updateAppointmentAssignedUsers,
  updateAppointmentStatusById,
  updateCancel,
  updateHospitalizationStatus,
  updateInpatientNoteReviewed,
  updateInpatientRedAlerts,
} from "../../../../redux/reducers/clinicSlice";
import { getVetHolidaysById } from "../../../../redux/reducers/doctorSlice";
import {
  hideLoader,
  showLoader,
  showLoaderText,
} from "../../../../redux/reducers/loaderSlice";
import {
  getPetPrescriptionsWoLoader,
  getPetsCompliantSummary,
  getPetsCompliantSummaryWoLoader,
} from "../../../../redux/reducers/petSlice";
import { assignBundleToAppointment } from "../../../../redux/reducers/planSlice";
import { showSnackBar } from "../../../../redux/reducers/snackSlice";
import { AppColors } from "../../../../util/AppColors";
import { movePatientList } from "../../../../util/arrayList";
import { inpatFieldMap } from "../../../../util/arrayMap";
import { addIcon } from "../../../../util/CommonIconStyle";
import {
  appointmentLaterList,
  appointmentList,
} from "../../../../util/dropList";
import {
  adjustTime,
  extractPrescriptionDetails,
  getCardColorByApptStatus,
  getRequiredSlotList,
  getRightSaluation,
  getTimeDiffInMins,
  getTypeByAppointmentType,
} from "../../../../util/function";
import BookAnAppointment from "../../../CommonScreens/BookAppointmentment/BookAnAppointment";
import UpdateRemarks from "../../../CommonScreens/UpdateRemarks/UpdateRemarks";
import Instructions from "./Instructions";
import OverviewDiagnostics from "./OverviewDiagnostics";

const cardSty = {
  borderRadius: 1,
  padding: 2,
  borderTopColor: AppColors.appPrimary,
};

const inpatientList = [
  "Summary",
  "Reminders",
  "InstructionsStatus",
  "AbnormalFindings",
  // "KeyIssues",
  "RedFlags",
  "OtherUpdates",
  "Observation",
  "ProgressNotes",
  "Conclusion",
  "Protocols",
];

const nameExten = {
  Summary: "Summary",
  Reminders: "Reminders",
  InstructionsStatus: "Instructions Status",
  AbnormalFindings: "Abnormal Findings",
  KeyIssues: "Key Issues",
  RedFlags: "Red Flags",
  OtherUpdates: "Other Updates",
  Observation: "Observation",
  ProgressNotes: "Progress Notes",
  Conclusion: "Conclusion",
  Protocols: "Protocols",
};

const Overview = ({
  // getPetData,
  isVideoCallEnabled,
  setVideoCallEnabled,
  setAllergyModOpen,
  appointment,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isEditAppointment, setEditAppointment] = useState(false);
  const [cancelModVsble, setCancelModVsble] = useState(false);
  const [noShowModVsble, setNoshowModVsble] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [reModVsble, setReModVsble] = useState(false);
  const [modValues, setModValues] = useState({});
  const [errors, setErrors] = useState({});
  const [vets, setVets] = useState([]);
  const [followUpModVsble, setFollowUpModVsble] = useState(false);
  const [selectTimeIdError, setSelectTimeIdError] = useState(false);
  const [remarksModVsble, setRemarksModVsble] = useState(false);
  const [selectTime, setSelectTime] = useState(null);
  const [selectedBundle, setSelectedBundle] = useState(null);
  const [bundleSearchValue, setBundleSearchValue] = useState("");
  const [bundleModVsble, setBundleModVsble] = useState(false);
  const [movPatModVsble, setMovPatModVsble] = useState(false);
  const [redAlertModVsble, setRedAlertModVsble] = useState(false);
  const [redFlagUpdatesVsble, setRedFlagUpdatesVsble] = useState(false);
  const [dailyUpdatesVsble, setDailyUpdatesVsble] = useState(false);
  const [assignUsersModVsble, setAssignUsersModVsble] = useState(false);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { petDetails, prescriptions, procedure } = useSelector(
    (state) => state?.pet,
  );
  const medHisList = useSelector(
    (state) => state?.medicalHistory?.medicalHistoryByPet,
  );
  const { petTreatmentBundles } = useSelector((state) => state?.plan);
  const {
    vetAvailability,
    vetBookedApnts,
    userDetails,
    details: clinicDetails,
    inpatientAlerts,
  } = useSelector((state) => state?.clinic);
  // const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const holidays = useSelector((state) => state?.doctor?.holidays);
  const apntId = appointment?.appoinment?.appointmentId;
  const appDet = reqDet?.appointment;
  const petId =
    appointment?.appoinment?.petId ??
    appDet?.petId ??
    reqDet?.appointment?.petId ??
    petDetails?.petId;
  const appointmentId = reqDet?.appointment?.appointmentId;
  const petData = apntId ? reqDet?.pet : petDetails;
  const petDet = apntId ? reqDet?.pet : petDetails;
  const apnt = reqDet?.appointment ?? appointment?.appoinment;
  const statusActive =
    typeof petData?.status === "boolean"
      ? petData?.status
      : petData?.status === "Y";
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { vets: clinicVets } = useMemo(() => {
    if (!mandateDataRaw) {
      return { vets: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
      };
    } catch {
      return { vets: [] };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    if (!petId) return;
    dispatch(
      getPetPrescriptionsWoLoader({
        petId,
        url: "?page=1&itemSize=5",
      }),
    );
  }, [petId, location.key, dispatch]);

  useEffect(() => {
    if (!reqDet?.appointment?.inpatient || !appointmentId) return;
    dispatch(getInpatientAlertsByAppointmentIdWoLoader(appointmentId));
  }, [reqDet?.appointment?.inpatient, appointmentId, location.key, dispatch]);

  useEffect(() => {
    const reqVetList = clinicVets
      ?.filter((vl) => {
        if (vl?.userType?.find((ut) => ut?.name === "ROLE_DOCTOR")) {
          return vl;
        }
      })
      ?.map((vet) => {
        return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
      });
    setVets(
      [
        {
          name: `${
            role === "ROLE_CLINIC" ? profile?.name : clinicDetails?.name
          } (Clinic)`,
          value: role === "ROLE_CLINIC" ? profile?.id : clinicDetails?.id,
          id: role === "ROLE_CLINIC" ? profile?.id : clinicDetails?.id,
        },
      ].concat(reqVetList),
    );
  }, [clinicVets]);

  useEffect(() => {
    if (
      appDet?.appointmentStatus?.toLowerCase() !== "scheduled" ||
      !modValues?.vetName?.value ||
      !modValues?.date ||
      !modValues?.appointmentOption
    ) {
      return;
    }
    if (modValues?.appointmentOption === "Later") {
      dispatch(getVetHolidaysById(modValues?.vetName?.value));
      dispatch(
        getAvailabilityByVetIdAndType({
          vetId: modValues?.vetName?.value,
          type: modValues?.consultationMode,
        }),
      );
      dispatch(
        getAppointmentsByVetIdAndDate({
          vetId: modValues?.vetName?.value,
          date: moment(new Date(modValues?.date)).format("YYYY-MM-DD"),
          clinicId: profile?.id,
        }),
      );
    }
  }, [
    modValues?.vetName?.value,
    modValues?.date,
    modValues?.appointmentOption,
    modValues?.consultationMode,
  ]);

  const myMeeting = async (element) => {
    const roomID = appDet?.videoCallId;
    const userID = appDet?.doctorId?.toString();
    const userName = appDet?.doctorName;
    const token = "faeb80d20908d605f3acbf67f8c25191";
    const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
      704271205,
      token,
      roomID,
      userID,
      userName,
    );

    const zp = ZegoUIKitPrebuilt.create(kitToken);
    zp.joinRoom({
      container: element,
      scenario: {
        mode: ZegoUIKitPrebuilt.GroupCall,
      },
      onLeaveRoom: async () => {
        setVideoCallEnabled(false);
        localStorage.setItem(
          "videoCallPageReloaded",
          JSON.stringify({
            state: appDet,
          }),
        );
        window.location.reload();
      },
      showLeavingView: false,
      showScreenSharingButton: false,
      maxUsers: 2,
      showPreJoinView: false,
      showTextChat: false,
      showRoomDetailsButton: false,
    });
  };

  const getAppointmentSummaryImgaes = () => {
    return (
      medHisList?.find((med) => med?.appointentId === appDet?.appointmentId)
        ?.appointmentImage ?? null
    );
  };

  const handleBundleclose = () => {
    setSelectedBundle(null);
    setBundleModVsble(false);
    setBundleSearchValue("");
  };

  const handleAssign = () => {
    if (!selectedBundle?.bundleId || !apntId) return;
    dispatch(
      assignBundleToAppointment({
        bundleId: selectedBundle?.bundleId,
        appointmentId: apntId,
      }),
    ).then((res) => {
      if (res?.payload) {
        dispatch(getPetsCompliantSummary(apntId));
        handleBundleclose();
      }
    });
  };

  const getRequiredPresData = () => {
    const getAllList = extractPrescriptionDetails(prescriptions?.data);
    const reqList = getAllList?.filter(
      (li) => new Date(li?.endDate) >= new Date(new Date().setHours(0, 0, 0)),
    );
    return reqList;
  };

  const onCancelModClose = () => {
    setCancelModVsble(false);
    setCancelReason("");
  };

  const onApiCall = () => {
    dispatch(getPetsCompliantSummary(apntId));
  };

  const onConfirmCancel = () => {
    dispatch(
      updateCancel({
        appId: apntId,
        reason: cancelReason,
      }),
    ).then((res) => {
      if (res?.payload) {
        onCancelModClose();
        onApiCall();
      }
    });
  };

  const onReModClose = () => {
    setReModVsble(false);
    setModValues({});
    setErrors({});
    setSelectTime(null);
    setSelectTimeIdError(false);
  };

  const onChangeValue = (name, value) => {
    setModValues({ ...modValues, [name]: value });
    if (
      appDet?.appointmentStatus?.toLowerCase() === "consultation" ||
      appDet?.appointmentStatus?.toLowerCase() === "finalize" ||
      appDet?.appointmentStatus?.toLowerCase() === "completed"
    ) {
      const reqValue =
        typeof value === "object"
          ? typeof value?.value === "number"
            ? value?.value?.toString()
            : value?.value
          : value;
      setErrors({
        ...errors,
        [name]: reqValue?.length > 0 ? false : "Required Field",
      });
    }
  };

  const handleSelectTime = (time) => {
    setSelectTime(time?.startTime);
    setSelectTimeIdError(false);
  };

  const onSaveRe = () => {
    if (
      appDet?.appointmentStatus?.toLowerCase() === "scheduled" &&
      !selectTime &&
      modValues?.appointmentOption !== "Immediate"
    ) {
      return setSelectTimeIdError(true);
    }
    if (!validateFields()) return;
    if (appDet?.appointmentStatus?.toLowerCase() !== "scheduled") {
      if (!modValues?.vetName?.value) return;
      dispatch(showLoader());
      const data = { doctorId: modValues?.vetName?.value };
      if (modValues?.assignedUsers?.length > 0) {
        data.assignedUsers = modValues?.assignedUsers?.map((li) => li?.value);
      }
      // const form = new FormData();
      // form.append("doctorId", modValues?.vetName?.value);
      dispatch(clinicReassignAppointment({ appointmentId: apntId, data })).then(
        (res) => {
          if (res?.payload) {
            onReModClose();
            onApiCall();
          }
        },
      );
      dispatch(hideLoader());
    } else {
      dispatch(showLoader());
      const data = {
        appointmentDate: moment(new Date(modValues?.date)).format("YYYY-MM-DD"),
        doctorId: modValues?.vetName?.value,
        appointmentStartTime: selectTime,
      };
      data.appointmentEndTime = adjustTime(
        selectTime,
        getTimeDiffInMins(
          appDet?.appointmentStartTime,
          appDet?.appointmentEndTime,
        )?.totalMinutes ?? 0,
        // getRequiredSlotList({
        //   availability: vetAvailability,
        //   date: modValues?.date,
        //   isDuration: true,
        // })
      );
      dispatch(
        clinicRescheduleAppointment({ appointmentId: apntId, data }),
      ).then((res) => {
        if (res?.payload) {
          onReModClose();
          onApiCall();
        }
      });
      dispatch(hideLoader());
    }
  };

  const validateFields = () => {
    const newErrors = {};
    if (!modValues?.vetName?.value)
      newErrors.vetName = "This field is required";
    if (!modValues?.appointmentOption)
      newErrors.appointmentOption = "Appointment Type is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onHandleRe = () => {
    setModValues({
      ...modValues,
      appointmentTime: appDet?.appointmentTime ?? appDet?.appointmentStartTime,
      appointmentId: appDet?.appointmentId,
      appointmentDate: appDet?.appointmentDate,
      bookingType: "Walk-in",
      consultationMode: appDet?.appointmentType,
      serviceType: appDet?.serviceType,
      reason: appDet?.reason,
      vetName: vets?.find((vet) => vet?.value === appDet?.doctorId) ?? null,
      appointmentOption: appDet?.immediate ? "Immediate" : "Later",
      date: new Date(appDet?.appointmentDate),
    });
    setReModVsble(true);
  };

  const onCloseFollowUpMod = () => {
    setEditAppointment(false);
    setFollowUpModVsble(false);
    setModValues({});
    setSelectTime(null);
    setSelectTimeIdError(false);
    setErrors({});
  };

  const handleFollowUp = () => {
    setModValues({
      ...modValues,
      bookingType: "Phone",
      consultationMode: "Physical",
      reason: "",
      vetName: null,
      appointmentOption: "",
      date: new Date(),
      serviceType: { name: "Follow-up", value: "Follow-up" },
    });
    setFollowUpModVsble(true);
  };

  const handleEditRemarks = () => {
    setRemarksModVsble(true);
  };

  const onCloseRemarks = () => {
    setRemarksModVsble(false);
  };

  const handleMovePatinet = () => {
    setModValues({
      moveTo:
        !reqDet?.inpatient?.hospitalization ?? movePatientList?.[0]?.value,
    });
    setMovPatModVsble(true);
  };

  const onCloseModPatMod = () => {
    setMovPatModVsble(false);
    setModValues({});
  };

  const onChangeMovePat = (name, value) => {
    setModValues({ ...modValues, [name]: value });
  };

  const onMovePatient = () => {
    if (!reqDet?.inpatient?.patientId) return;
    dispatch(
      updateHospitalizationStatus({
        patientId: reqDet?.inpatient?.patientId,
        status: modValues?.moveTo,
      }),
    ).then((res) => {
      if (res?.payload) {
        if (modValues?.moveTo === false) {
          dispatch(
            updateAppointmentStatusById({
              appointmentId: reqDet?.appointment?.appointmentId,
              status: "scheduled",
              successMsg: "Status updated successfully!",
            }),
          ).then((res2) => {
            if (res2?.payload) {
              onApiCall();
              onCloseModPatMod();
            }
          });
          return;
        }
        onApiCall();
        onCloseModPatMod();
      }
    });
  };

  const handleAddUpdateRedAlert = (itm) => {
    setModValues({ alert: itm?.text ?? "", alertId: itm?.alertId ?? null });
    setRedAlertModVsble(true);
  };

  const onCloseRedAlertMod = () => {
    setRedAlertModVsble(false);
    setModValues({});
  };

  const onSaveRedAlert = () => {
    if (!reqDet?.inpatient?.patientId) return;
    const data = {
      inpatientId: reqDet?.inpatient?.patientId,
      doctorId: reqDet?.appointment?.doctorId,
      text: modValues?.alert,
    };
    if (modValues?.alertId) {
      data.alertId = modValues?.alertId;
    }
    dispatch(updateInpatientRedAlerts(data)).then((res) => {
      if (res?.payload) {
        onCloseRedAlertMod();
        onApiCall();
      }
    });
  };

  function toObject(data) {
    try {
      if (typeof data === "string") {
        return JSON.parse(data);
      }
      if (typeof data === "object" && data !== null) {
        return data;
      }
      throw new Error("Unsupported data type");
    } catch (err) {
      console.error("Error converting to object:", err);
      return null;
    }
  }

  const getApptDetailsForSoap = () => {
    const reqObj = {
      petName: petDet?.petName ?? apnt?.petName ?? "",
      species: petDet?.petType ?? "",
      breed: petDet?.breed ?? apnt?.breed ?? "",
      age: petDet?.dob ?? apnt?.dob ?? "",
      reproductiveStatus: petDet?.reproductiveStatus ?? "",
      gender: petDet?.gender ?? apnt?.gender ?? "",
      weight: petDet?.weight ?? apnt?.weight ?? "",
      appointmentDateTime: apnt?.appointmentdateTime ?? "",
      bloodGroup: petDet?.bloodGroup ?? apnt?.bloodGroup ?? "",
      temperament: petDet?.temperament ?? apnt?.temperament ?? "",
      color: petDet?.color ?? apnt?.color ?? "",
      rfid: petDet?.rfid ?? apnt?.rfid ?? "",
      veterinaryClinic: clinicDetails?.name ?? "",
      username: petDet?.userName ?? apnt?.userName ?? "",
      vetName: apnt?.doctorName ?? "",
      appointmentId: apnt?.appointmentId ?? "",
    };
    return JSON.stringify(reqObj);
  };

  const onConsolidateSoap = async (typ = "inpatient") => {
    const reqList = reqDet?.inpatientNotes?.filter(
      (li) =>
        li?.appointmentId === reqDet?.appointment?.appointmentId &&
        li?.type?.toLowerCase() === typ?.toLowerCase() &&
        !li?.isMaual &&
        !li?.consolidated,
    );
    if (reqList?.length === 0 || reqList?.length === 1) return;
    const soap_notes = reqList?.map((obj) =>
      inpatFieldMap
        ?.map(([k, src]) => {
          const raw = (obj[src] ?? "").toString();
          const safe = raw?.replace(/\r?\n/g, " ")?.replace(/'/g, "\\'");
          return `${k}:'${safe}'`;
        })
        ?.join(","),
    );
    dispatch(showLoader());
    dispatch(showLoaderText("Please wait while we consolidate the SOAP notes"));
    dispatch(
      setApiInProgress({ apiType: "consolidateSoap", inProgress: true }),
    );
    const res = await soapApiJson.post("/consolidate-soap-notes", {
      soap_notes,
      case_type: typ,
      appt_details: getApptDetailsForSoap(),
    });
    if (res?.status === 200) {
      dispatch(
        setApiInProgress({ apiType: "consolidateSoap", inProgress: false }),
      );
      if (res?.data?.consolidated_soap_note) {
        const reqObj = toObject(res?.data?.consolidated_soap_note);
        dispatch(hideLoader());
        dispatch(showLoaderText(""));
        const apiObj = {
          ...reqObj,
          sessionId: res?.data?.session_id ?? reqObj?.session_id ?? "",
          modificationCount:
            res?.data?.modification_count ?? reqObj?.modification_count ?? 0,
          consolidated: true,
          type: typ,
          Protocols: reqObj?.Protocols ?? "",
          ProgressNotes: reqObj?.ProgressNotes ?? "",
          Conclusion: reqObj?.Conclusion ?? "",
        };
        onUpdateNote(apiObj);
      } else {
        dispatch(
          setApiInProgress({ apiType: "consolidateSoap", inProgress: false }),
        );
        dispatch(hideLoader());
        dispatch(showLoaderText(""));
      }
    } else {
      dispatch(
        setApiInProgress({ apiType: "consolidateSoap", inProgress: false }),
      );
      dispatch(hideLoader());
      dispatch(showLoaderText(""));
    }
  };

  const onUpdateNote = ({
    Subjective = "",
    Objective = "",
    Assessment = "",
    Plan = "",
    Conclusion = "",
    DifferentialDiagnosis = "",
    KeyIssues = "",
    AbnormalFindings = "",
    CustomerInstructions = "",
    Reminders = "",
    sessionId = "",
    transcript = "",
    modificationCount = 0,
    blob = null,
    type = "outpatient",
    Summary = "",
    InstructionsStatus = "",
    RedFlags = "",
    OtherUpdates = "",
    Observation = "",
    consolidated = false,
    Protocols = "",
    ProgressNotes = "",
    PreSurgicalDocumentation = "",
    IntraSurgicalDocumentation = "",
    PostSurgicalDocumentation = "",
    OwnerCommunication = "",
    AdditionalDocumentation = "",
  }) => {
    const form = new FormData();
    form.append("subjective", Subjective);
    form.append("objective", Objective);
    form.append("assessment", Assessment);
    form.append("plan", Plan);
    form.append("conclusion", Conclusion);
    form.append("tag", DifferentialDiagnosis);
    form.append("keyIssues", KeyIssues);
    form.append("abnormalFindings", AbnormalFindings);
    form.append("customerInstructions", CustomerInstructions);
    form.append("reminders", Reminders);
    form.append("summary", Summary);
    form.append("instructionsStatus", InstructionsStatus);
    form.append("redFlags", RedFlags);
    form.append("otherUpdates", OtherUpdates);
    form.append("observation", Observation);
    form.append("sessionId", sessionId);
    form.append("modificationCount", modificationCount);
    form.append("type", type);
    form.append("consolidated", consolidated);
    form.append("preSurgicalDocumentation", PreSurgicalDocumentation);
    form.append("intraSurgicalDocumentation", IntraSurgicalDocumentation);
    form.append("postSurgicalDocumentation", PostSurgicalDocumentation);
    form.append("ownerCommunication", OwnerCommunication);
    form.append("additionalDocumentation", AdditionalDocumentation);
    if (consolidated) {
      form.append("protocols", Protocols);
      form.append("progressNotes", ProgressNotes);
    }
    if (transcript?.length > 0) form.append("transcript", transcript);
    dispatch(postClinicalNotesWoLoader({ appId: apntId, form })).then((res) => {
      if (res?.payload) {
        dispatch(getPetsCompliantSummaryWoLoader(apntId));
        dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
      }
    });
  };

  const onViewRedFlagUpdates = () => {
    setRedFlagUpdatesVsble(true);
  };

  const onViewDailyUpdates = () => {
    setDailyUpdatesVsble(true);
  };

  const onUpdateReviewed = (itm) => {
    dispatch(
      updateInpatientNoteReviewed({ noteId: itm?.noteId, reviewed: true }),
    ).then((res) => {
      if (res?.payload) {
        onApiCall();
        setDailyUpdatesVsble(false);
      }
    });
  };

  const onAssignUsers = () => {
    const assignedUsers =
      appDet?.assignedUsers?.length > 0
        ? appDet?.assignedUsers?.map((li) => {
            const matUser = clinicVets?.find((vl) => vl?.doctorId === li);
            return { id: li, name: matUser?.name, value: li };
          })
        : [];
    setModValues({ assignedUsers });
    setAssignUsersModVsble(true);
  };

  const getAllClinicUserListWoSelectedVet = (vetId = null) => {
    if (!vetId) return [];
    const reqVetList =
      clinicVets
        ?.filter((vl) => vl?.status === "Y" && vl?.doctorId !== vetId)
        ?.map((vet) => {
          return { name: vet?.name, value: vet?.doctorId, id: vet?.doctorId };
        }) ?? [];
    return reqVetList;
  };

  const onCloseAssignUsersMod = () => {
    setAssignUsersModVsble(false);
    setModValues({});
    setErrors({});
  };

  const onUpdateAssignedUsers = () => {
    const reqAssinUserIds =
      modValues?.assignedUsers?.length > 0
        ? (modValues?.assignedUsers?.map((li) => li?.id) ?? [])
        : [];
    dispatch(
      updateAppointmentAssignedUsers({
        apntId,
        data: { assignedUsers: reqAssinUserIds },
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseAssignUsersMod();
        onApiCall();
      }
    });
  };

  const onHandleNoShow = () => {
    setNoshowModVsble(true);
  };

  const onCloseNoShowMod = () => {
    setNoshowModVsble(false);
  };

  const onConfirmNoShow = () => {
    if (!reqDet?.appointment?.appointmentId && !apntId) return;
    dispatch(
      updateAppointmentStatusById({
        appointmentId: reqDet?.appointment?.appointmentId ?? apntId,
        status: "noshow",
        successMsg: "No show added successfully!",
      }),
    ).then((res) => {
      if (res?.payload) {
        onCloseNoShowMod();
        onApiCall();
      }
    });
  };

  return (
    <>
      {isVideoCallEnabled ? (
        <div ref={myMeeting} className="vid-cal-con" />
      ) : null}

      <Grid container className="mv3 back-white pb100">
        {apntId ? (
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="mh10 mtMin10">
              <div className="appointmentBdrlft cardWHeader br8">
                <div className="bg-body bdrBtm flex-row-between-align-center pt10 pb10 pl15 pr15">
                  <Typography className="fs13 txt-semi-bold clr-dark-gray">
                    Appointment Details
                  </Typography>
                  {appDet?.appointmentStatus?.toLowerCase() ===
                  "cancelled" ? null : (
                    <Typography
                      className="fs13 txt-semi-bold cursor blue-color"
                      onClick={() => setEditAppointment(true)}
                    >
                      Edit
                    </Typography>
                  )}
                </div>
                <div className="gry-hor-split3" />
                <div className="pt10 pb10 pl15 pr15">
                  <div className="flex-row-between">
                    <div>
                      <div className="flex-row-ali-cen">
                        <Typography className="fs14 txt-semi-bold">
                          {`Meeting ${getRightSaluation(clinicVets, appDet?.doctorId)}
                  ${appDet?.doctorName}
                  ${
                    appDet?.facilityId && appDet?.facility
                      ? ` · Facility: ${appDet?.facility}`
                      : ""
                  }
                  `}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <Typography className="fs12 font-medium clr-dark-gray">
                          {`${appDet?.serviceType} · ${moment(appDet?.appointmentdateTime).format("DD MMM YYYY, HH:mm")}`}
                        </Typography>
                      </div>
                    </div>
                    <div>
                      <div className="flex-row-ali-cen">
                        <Typography
                          className={`font-medium fs10 pv2 ph10 white-color br5
                                    flex-center  ${
                                      appDet?.appointmentType === "Physical"
                                        ? "card-bot-blue-back"
                                        : "virtual-bg"
                                    }`}
                        >
                          {appDet?.appointmentType === "Home"
                            ? "Home Visit"
                            : appDet?.appointmentType}
                        </Typography>
                        <Typography
                          className={`ml10 fs10 txt-semi-bold white-color con-fit flex-center ph10 pv2 br5 ${getCardColorByApptStatus(
                            appDet?.appointmentStatus?.toLowerCase(),
                            appDet?.appointmentType,
                          )}`}
                        >
                          {getTypeByAppointmentType(
                            appDet?.appointmentStatus,
                            appDet?.appointmentType,
                          )}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div className="flex-row-ali-cen mt5">
                    {appDet?.appointmentStatus?.toLowerCase() !== "completed" &&
                      appDet?.appointmentStatus?.toLowerCase() !==
                        "cancelled" && (
                        <div>
                          <CustomButton
                            smallBtn
                            text="Assign Users"
                            onClick={onAssignUsers}
                          />
                        </div>
                      )}
                    {(appDet?.appointmentStatus?.toLowerCase() ===
                      "scheduled" ||
                      appDet?.appointmentStatus?.toLowerCase() ===
                        "inprogress" ||
                      appDet?.appointmentStatus?.toLowerCase() ===
                        "intransit") && (
                      <div className="ml10">
                        <CustomButton
                          smallBtn
                          text="Cancel"
                          redBtn
                          onClick={() => setCancelModVsble(true)}
                        />
                      </div>
                    )}
                    {(appDet?.appointmentStatus?.toLowerCase() ===
                      "consultation" ||
                      appDet?.appointmentStatus?.toLowerCase() === "finalize" ||
                      appDet?.appointmentStatus?.toLowerCase() ===
                        "completed") && (
                      <div className="ml10">
                        <CustomButton
                          smallBtn
                          text="Follow-up"
                          yellowBtn
                          onClick={handleFollowUp}
                        />
                      </div>
                    )}
                    {appDet?.appointmentType === "Physical" &&
                      (appDet?.appointmentStatus?.toLowerCase() ===
                        "scheduled" ||
                        appDet?.appointmentStatus?.toLowerCase() ===
                          "inprogress") && (
                        <div className="ml10">
                          <CustomButton
                            smallBtn
                            text="No Show"
                            onClick={onHandleNoShow}
                            yellowBtn
                          />
                        </div>
                      )}
                  </div>
                  <div className="flex-row-ali-cen mt5">
                    <Typography className="clr-dark-gray fs12 font-medium">
                      Remarks:
                    </Typography>
                    <Typography className="fs12 txt-regular ml5">
                      {appDet?.remarks?.length > 0 ? appDet?.remarks : "---"}
                    </Typography>
                  </div>
                </div>
              </div>

              <div className="br8 cardWHeader bg-body flex-row-between pt10 pb10 pl15 pr15 mt15">
                <Typography className="fs13 txt-semi-bold clr-dark-gray flex-row-ali-cen flex-row-wrap">
                  Allergies:{" "}
                  {(apntId || apnt?.petId) && petData?.allergies?.length > 0 ? (
                    petData?.allergies?.map((al, i) => (
                      <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                        {`${al?.allergies}${
                          i + 1 === petData?.allergies?.length ? "" : ","
                        }`}
                      </Typography>
                    ))
                  ) : (
                    <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                      None specified
                    </Typography>
                  )}
                </Typography>
                {statusActive ? (
                  <Typography
                    className="cursor greentick card-green-color txt-semi-bold fs13"
                    onClick={() => setAllergyModOpen(true)}
                  >
                    ✓
                  </Typography>
                ) : null}
              </div>

              {!appDet?.inpatient ? (
                <>
                  {/* <div className="cardWHeader br8 mt15">
                    <div className="bg-body fs13 bdrBtm pt10 pb10 pl15 pr15">
                      <Typography className="fs13 txt-semi-bold clr-dark-gray">
                        Appointment Summary
                      </Typography>
                    </div>
                    {appDet?.appointmentSummary?.length > 0 ? (
                      <div>
                        <Typography className="mt10 fs14 txt-regular">
                          {appDet?.appointmentSummary}
                        </Typography>
                        {getAppointmentSummaryImgaes()?.length > 0 ? (
                          <div className="flex-row-ali-cen flex-row-wrap mt20">
                            {getAppointmentSummaryImgaes()?.map((img, i) => (
                              <img
                                key={img?.id + i}
                                src={img?.image}
                                alt=""
                                className="img2 br5 m5"
                              />
                            ))}
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      <div className="no-rec h50">No records available</div>
                    )}
                  </div> */}

                  {/* <div className="cardWHeader br8 mt15">
                    <div className="bg-body fs13 bdrBtm pt10 pb10 pl15 pr15">
                      <Typography className="fs13 txt-semi-bold clr-dark-gray">
                        Clinical Summary
                      </Typography>
                    </div>
                    {appDet?.clinicalSummary?.length > 0 ? (
                      <Typography className="mt10 fs14 txt-regular">
                        {appDet?.clinicalSummary}
                      </Typography>
                    ) : (
                      <div className="no-rec h50">No records available</div>
                    )}
                  </div> */}

                  <div className="cardWHeader br8 mt15">
                    <div className="bg-body fs13 bdrBtm pt10 pb10 pl15 pr15">
                      <Typography className="fs13 txt-semi-bold clr-dark-gray">
                        Active Medications
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen ph10 pb10">
                      {apntId && getRequiredPresData()?.length > 0 ? (
                        getRequiredPresData()
                          ?.slice(0, 5)
                          ?.map((ml, i) => (
                            <>
                              <div className="w30Per">
                                <div className="flex-column">
                                  <Tooltip title={ml?.name || ""}>
                                    <Typography
                                      className="txt-semi-bold black2 fs12 capitalize"
                                      sx={{
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                        wordBreak: "break-word",
                                      }}
                                    >
                                      {ml?.name}
                                    </Typography>
                                  </Tooltip>
                                  {/* <Typography className="txt-semi-bold gray7 fs12 mt10">
                                    {ml?.name ?? ""}
                                  </Typography> */}
                                  {ml?.date ? (
                                    <div className="flex-row-ali-cen mt10">
                                      <div className="gray-dot2" />
                                      <Typography className="txt-semi-bold fs12 ml5 black2">
                                        Prescribed Date:{" "}
                                        {moment(ml?.date).format("DD MMM YYYY")}
                                      </Typography>
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              {getRequiredPresData()?.slice(0, 5)?.length !==
                              i + 1 ? (
                                <div className="w5Per">
                                  <div className="flex-center">
                                    <div className="ver-bar-h30 h50" />
                                  </div>
                                </div>
                              ) : null}
                            </>
                          ))
                      ) : (
                        <div className="no-rec h50">No records available</div>
                      )}
                    </div>
                  </div>
                </>
              ) : null}
            </div>

            {/* <div className="flex-row-ali-cen mb20">
              <div className="w100Per">
                <div className="blue-box-examD">
                  <div className="flex-row">
                    <div className="w40Per">
                      <Typography className="fs16 blue-color font-bold">
                        Appointment Details
                      </Typography>
                      <Typography className="card-black1 fs14 txt-semi-bold">
                        Meeting{" "}
                        {getRightSaluation(clinicVets, appDet?.doctorId)}
                        {appDet?.doctorName}
                      </Typography>
                      {appDet?.assignedUsers?.length > 0 ? (
                        <Typography className="card-black1 fs12 txt-semi-bold">
                          Assigned Users:{" "}
                          {clinicVets
                            ?.filter((vl) =>
                              appDet?.assignedUsers?.some(
                                (li) => li === vl?.doctorId,
                              ),
                            )
                            ?.map((li) => li?.name)
                            ?.join(", ")}
                        </Typography>
                      ) : null}
                      {appDet?.facilityId ? (
                        <Typography className="card-black1 fs12 txt-semi-bold">
                          Facility: {appDet?.facility}
                        </Typography>
                      ) : null}
                    </div>
                    <div className="w30Per">
                      <div className="flex-row-ali-cen">
                        <img
                          src={require("../../../../assets/images/png/calen.png")}
                          className="img-wh15"
                        />
                        <Typography className="gray25 fs14 font-bold ml5">
                          {moment(appDet?.appointmentDate).format(
                            "DD MMM YYYY",
                          )}
                        </Typography>
                      </div>
                      <div className="flex-row-ali-cen">
                        <img
                          src={require("../../../../assets/images/png/clock.png")}
                          className="img-wh15"
                        />
                        <Typography className="gray25 fs14 font-bold ml5">
                          {appDet?.appointmentStartTime ??
                            moment(
                              new Date(appDet?.appointmentdateTime),
                            ).format("HH:mm")}
                        </Typography>
                      </div>
                    </div>
                    <div className="flex1-end">
                      <div>
                        {appDet?.appointmentStatus?.toLowerCase() !==
                        "completed" ? (
                          <div className="flex1-end">
                            <div
                              className="flex-row-ali-cen cursor"
                              onClick={() => setEditAppointment(true)}
                            >
                              <Typography className="fs8 blue-color txt-semi-bold">
                                Edit Appointment
                              </Typography>
                              <img
                                src={require("../../../../assets/images/png/edit2.png")}
                                className="img-wh10 ml5"
                              />
                            </div>
                          </div>
                        ) : null}
                        <div className="flex1-end mt10">
                          <div className="flex-row-ali-cen">
                            <Typography
                              className={`font-medium fs10 card-time  white-color
                                    flex-center  ${
                                      appDet?.appointmentType === "Physical"
                                        ? "card-bot-blue-back"
                                        : "virtual-bg"
                                    }`}
                            >
                              {appDet?.appointmentType === "Home"
                                ? "Home Visit"
                                : appDet?.appointmentType}
                            </Typography>

                        //     <Typography
                        //   className={`font-medium fs10 ml10 card-time  white-color
                        //             flex-center  gray-back3`}
                        // >
                        //   Follow-up
                        // </Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Typography className="light-blue fs14 txt-semi-bold">
                    {appDet?.serviceType}
                    {appDet?.serviceType === "Consultation"
                      ? ` | ${
                          Array.isArray(appDet?.reason)
                            ? appDet?.reason?.join(", ")
                            : ""
                        }`
                      : ""}
                  </Typography>

                  <div className="flex-row-ali-cen mt5">
                    <div className="w50Per">
                      <div className="flex-row-ali-cen">
                        <Typography className="card-black1 fs14 txt-semi-bold">
                          Remarks:
                        </Typography>
                        //  <img
                        //   src={require("../../../../assets/images/png/edit-new.png")}
                        //   alt=""
                        //   className="img-wh20 ml10 cursor"
                        //   onClick={handleEditRemarks}
                        // /> 
                      </div>
                      <Typography className="black fs12 font-medium">
                        {appDet?.remarks}
                      </Typography>
                    </div>

                    <div className="flex1-end">
                      <div className="flex-row-ali-cen">
                        {(appDet?.appointmentStatus?.toLowerCase() !==
                          "completed" ||
                          appDet?.appointmentStatus?.toLowerCase() !==
                            "cancelled") && (
                          <div>
                            <CustomButton
                              smallBtn
                              text="Assign Users"
                              onClick={onAssignUsers}
                            />
                          </div>
                        )}
                        {(appDet?.appointmentStatus?.toLowerCase() ===
                          "scheduled" ||
                          appDet?.appointmentStatus?.toLowerCase() ===
                            "inprogress" ||
                          appDet?.appointmentStatus?.toLowerCase() ===
                            "intransit") && (
                          <div className="ml10">
                            <CustomButton
                              smallBtn
                              text="Cancel"
                              redBtn
                              onClick={() => setCancelModVsble(true)}
                            />
                          </div>
                        )}
                        //  {appDet?.appointmentStatus?.toLowerCase() ===
                        //   "scheduled" && (
                        //   <div className="ml10">
                        //     <CustomButton
                        //       smallBtn
                        //       text="Reschedule"
                        //       onClick={onHandleRe}
                        //     />
                        //   </div>
                        // )}
                        // {(appDet?.appointmentStatus?.toLowerCase() ===
                        //   "inprogress" ||
                        //   appDet?.appointmentStatus?.toLowerCase() ===
                        //     "intransit") && (
                        //   <div className="ml10">
                        //     <CustomButton
                        //       smallBtn
                        //       text="Reassign"
                        //       onClick={onHandleRe}
                        //     />
                        //   </div>
                        // )}
                        {(appDet?.appointmentStatus?.toLowerCase() ===
                          "consultation" ||
                          appDet?.appointmentStatus?.toLowerCase() ===
                            "finalize" ||
                          appDet?.appointmentStatus?.toLowerCase() ===
                            "completed") && (
                          <div className="ml10">
                            <CustomButton
                              smallBtn
                              text="Follow-up"
                              yellowBtn
                              onClick={handleFollowUp}
                            />
                          </div>
                        )}
                        {appDet?.appointmentType === "Physical" &&
                          (appDet?.appointmentStatus?.toLowerCase() ===
                            "scheduled" ||
                            appDet?.appointmentStatus?.toLowerCase() ===
                              "inprogress") && (
                            <div className="ml10">
                              <CustomButton
                                smallBtn
                                text="No Show"
                                onClick={onHandleNoShow}
                                yellowBtn
                              />
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  <Divider className="mv10" />
                  //  {appDet?.inpatient &&
                  // reqDet?.inpatient?.hospitalization &&
                  // ["insurgery", "recovery"].includes(
                  //   reqDet?.appointment?.appointmentStatus?.toLowerCase()
                  // ) ? (
                  //   // !reqDet?.inpatient?.hospitalization
                  //   // ? ["insurgery", "recovery"].includes(
                  //   //     reqDet?.appointment?.appointmentStatus?.toLowerCase()
                  //   //   )
                  //   // : ["recovery"].includes(
                  //   //     reqDet?.appointment?.appointmentStatus?.toLowerCase()
                  //   //   )
                  //   <div className="flex1-end">
                  //     <div>
                  //       <CustomButton
                  //         text="Move Patient"
                  //         smallBtn
                  //         onClick={handleMovePatinet}
                  //       />
                  //     </div>
                  //   </div>
                  // ) : null}
                </div>
              </div>
            </div> */}
          </Grid>
        ) : null}
        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row-ali-cen mv5">
            <div className="flex-row ovr-head-back">
              <img
                src={require("../../../../assets/images/png/allergyIcon.png")}
                alt=""
                className="img-wh20 ml10"
              />
              <Typography className="txt-semi-bold fs14 balck ml10">
                Alerts:
              </Typography>
              {(apntId || apnt?.petId) && petData?.allergies?.length > 0 ? (
                petData?.allergies?.map((al, i) => (
                  <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                    {`${al?.allergies}${
                      i + 1 === petData?.allergies?.length ? "" : ","
                    }`}
                  </Typography>
                ))
              ) : (
                <Typography className="txt-semi-bold fs14 card-head-orange-color ml5">
                  None specified
                </Typography>
              )}
              {statusActive ? (
                <div className="flex1-end">
                  <img
                    src={require("../../../../assets/images/png/edit-new.png")}
                    alt=""
                    className="img-wh20 ml10 cursor"
                    onClick={() => setAllergyModOpen(true)}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </Grid> */}
        {!appDet?.inpatient ? (
          <>
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold mt20 fs14">
                Appointment Summary
              </Typography>
            </Grid>
            {appDet?.appointmentSummary?.length > 0 ? (
              <div>
                <Typography className="mt10 fs14 txt-regular">
                  {appDet?.appointmentSummary}
                </Typography>
                {getAppointmentSummaryImgaes()?.length > 0 ? (
                  <div className="flex-row-ali-cen flex-row-wrap mt20">
                    {getAppointmentSummaryImgaes()?.map((img, i) => (
                      <img
                        key={img?.id + i}
                        src={img?.image}
                        alt=""
                        className="img2 br5 m5"
                      />
                    ))}
                  </div>
                ) : null}
              </div>
            ) : (
              <div className="no-rec h50">No records available</div>
            )} */}

            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold mt20 fs14">
                Clinical Summary
              </Typography>
            </Grid>
            {appDet?.clinicalSummary?.length > 0 && appDet?.petId !== 17 ? (
              <Typography className="mt10 fs14 txt-regular">
                {appDet?.clinicalSummary}
              </Typography>
            ) : (
              <div className="no-rec h50">No records available</div>
            )} */}

            {/* <div className="w100Per">
              <PreventiveHistory />
            </div> */}

            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="mt20">
              <Typography className="font-bold fs14">
                Active Medications
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                {apntId && getRequiredPresData()?.length > 0 ? (
                  getRequiredPresData()
                    ?.slice(0, 5)
                    ?.map((ml, i) => (
                      <>
                        <div className="w30Per">
                          <div className="flex-column">
                            <Typography className="txt-semi-bold gray7 fs12 mt10">
                              {ml?.name ?? ""}
                            </Typography>
                            {ml?.date ? (
                              <div className="flex-row-ali-cen mt10">
                                <div className="gray-dot2" />
                                <Typography className="txt-semi-bold fs12 ml5 black2">
                                  Prescribed Date:{" "}
                                  {moment(ml?.date).format("DD MMM YYYY")}
                                </Typography>
                              </div>
                            ) : null}
                          </div>
                        </div>

                        {getRequiredPresData()?.slice(0, 5)?.length !==
                        i + 1 ? (
                          <div className="w5Per">
                            <div className="flex-center">
                              <div className="ver-bar-h30 h50" />
                            </div>
                          </div>
                        ) : null}
                      </>
                    ))
                ) : (
                  <div className="no-rec h50">No records available</div>
                )}
              </div>
            </Grid> */}
            <div className="w100Per">
              <OverviewDiagnostics />
            </div>
          </>
        ) : null}

        {reqDet?.appointment?.inpatient && appDet?.inpatient ? (
          <>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="mh10">
                <div className="cardWHeader br8 bg-body mt15 pt10 pb10 pl15 pr15">
                  <div className="flex-row-between">
                    <div className="pos-rel">
                      <Typography className="fs13 txt-semi-bold clr-dark-gray">
                        Daily Updates
                      </Typography>
                      {reqDet?.inpatientNotes?.filter(
                        (li) =>
                          li?.appointmentId ===
                            reqDet?.appointment?.appointmentId &&
                          li?.type?.toLowerCase() === "inpatient" &&
                          li?.consolidated === true &&
                          li?.reviewed === false,
                      )?.length > 0 ? (
                        <div className="not-count pos-absolute top0 rightMin15">
                          <Typography className="white-color flex-center fs8">
                            {
                              reqDet?.inpatientNotes?.filter(
                                (li) =>
                                  li?.appointmentId ===
                                    reqDet?.appointment?.appointmentId &&
                                  li?.type?.toLowerCase() === "inpatient" &&
                                  li?.consolidated === true &&
                                  li?.reviewed === false,
                              )?.length
                            }
                          </Typography>
                        </div>
                      ) : null}
                    </div>
                    {reqDet?.inpatientNotes?.filter(
                      (li) =>
                        li?.appointmentId ===
                          reqDet?.appointment?.appointmentId &&
                        li?.type?.toLowerCase() === "inpatient" &&
                        li?.consolidated === true,
                    )?.length > 0 ? (
                      <Typography
                        className="blue-color fs12 txt-semi-bold underline cursor"
                        onClick={onViewDailyUpdates}
                      >
                        View
                      </Typography>
                    ) : null}
                  </div>
                </div>

                <div className="cardWHeader br8 mt15">
                  <div className="bg-body fs13 bdrBtm pt10 pb10 pl15 pr15">
                    <Typography className="fs13 txt-semi-bold clr-dark-gray">
                      Progress Notes
                    </Typography>
                  </div>
                  {reqDet?.inpatientNotes?.find(
                    (li) =>
                      li?.appointmentId ===
                        reqDet?.appointment?.appointmentId &&
                      li?.type === "inpatient",
                  )?.progressNotes?.length > 0 ? (
                    <Typography className="mt10 fs12 txt-regular gray11">
                      {
                        reqDet?.inpatientNotes?.find(
                          (li) =>
                            li?.appointmentId ===
                              reqDet?.appointment?.appointmentId &&
                            li?.type === "inpatient",
                        )?.progressNotes
                      }
                    </Typography>
                  ) : (
                    <div className="flex-column flex1-center">
                      <div className="no-rec h50 pv20">
                        No records available
                      </div>
                      {reqDet?.inpatientNotes?.filter(
                        (li) =>
                          li?.appointmentId ===
                            reqDet?.appointment?.appointmentId &&
                          li?.type === "inpatient" &&
                          !li?.consolidated,
                      )?.length > 1 &&
                      reqDet?.inpatientNotes?.filter(
                        (li) =>
                          li?.appointmentId ===
                            reqDet?.appointment?.appointmentId &&
                          li?.type === "inpatient" &&
                          li?.consolidated,
                      )?.length === 0 ? (
                        <div className="mv20">
                          <CustomButton
                            text="Consolidate Daily SOAP"
                            onClick={() => onConsolidateSoap("inpatient")}
                            smallBtn
                          />
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>

                <div className="cardWHeader br8 bg-body mt15 pt10 pb10 pl15 pr15">
                  <div className="flex-row-between">
                    <Typography className="fs13 txt-semi-bold clr-dark-gray">
                      Red Flags
                    </Typography>
                    <div className="flex-row-ali-cen">
                      <div
                        className="flex-row-ali-cen cursor"
                        onClick={() => handleAddUpdateRedAlert(null)}
                      >
                        <div className="flex-center plus-icon">
                          <AddIcon sx={addIcon} />
                        </div>
                        <Typography className="blue-color fs14 ml5 font-bold">
                          Add
                        </Typography>
                      </div>
                      <Typography
                        className="blue-color fs12 txt-semi-bold underline cursor ml15"
                        onClick={onViewRedFlagUpdates}
                      >
                        View Updates
                      </Typography>
                    </div>
                  </div>
                  {(inpatientAlerts ?? [])?.map((alrt) => {
                    return (
                      <div className="red-con w100Per mt15" key={alrt?.alertId}>
                        <div className="flex-row">
                          <div className="w95Per">
                            <Typography className="black28 fs12 txt-regular">
                              {alrt?.text}
                            </Typography>
                          </div>
                          <div className="w5Per flex1-end">
                            <img
                              src={require("../../../../assets/images/png/edit-new.png")}
                              alt=""
                              className="img-wh20 cursor"
                              onClick={() => handleAddUpdateRedAlert(alrt)}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* <div className="flex-row-ali-cen pos-rel">
                <div className="rel-con">
                  <Typography className="font-bold mt10 fs14">
                    Daily Updates
                  </Typography>
                  {reqDet?.inpatientNotes?.filter(
                    (li) =>
                      li?.appointmentId ===
                        reqDet?.appointment?.appointmentId &&
                      li?.type?.toLowerCase() === "inpatient" &&
                      li?.consolidated === true &&
                      li?.reviewed === false,
                  )?.length > 0 ? (
                    <div className="not-count daily-updt-bat">
                      <Typography className="white-color flex-center fs8">
                        {
                          reqDet?.inpatientNotes?.filter(
                            (li) =>
                              li?.appointmentId ===
                                reqDet?.appointment?.appointmentId &&
                              li?.type?.toLowerCase() === "inpatient" &&
                              li?.consolidated === true &&
                              li?.reviewed === false,
                          )?.length
                        }
                      </Typography>
                    </div>
                  ) : null}
                </div>
                {reqDet?.inpatientNotes?.filter(
                  (li) =>
                    li?.appointmentId === reqDet?.appointment?.appointmentId &&
                    li?.type?.toLowerCase() === "inpatient" &&
                    li?.consolidated === true,
                )?.length > 0 ? (
                  <Typography
                    className="blue-color fs12 txt-semi-bold underline cursor pos-absolute r0"
                    onClick={onViewDailyUpdates}
                  >
                    View
                  </Typography>
                ) : null}
              </div> */}
            </Grid>

            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="font-bold mt10 fs14">
                Progress Notes
              </Typography>
            </Grid>
            {reqDet?.inpatientNotes?.find(
              (li) =>
                li?.appointmentId === reqDet?.appointment?.appointmentId &&
                li?.type === "inpatient",
            )?.progressNotes?.length > 0 ? (
              <Typography className="mt10 fs12 txt-regular gray11">
                {
                  reqDet?.inpatientNotes?.find(
                    (li) =>
                      li?.appointmentId ===
                        reqDet?.appointment?.appointmentId &&
                      li?.type === "inpatient",
                  )?.progressNotes
                }
              </Typography>
            ) : (
              <div className="flex-column flex1-center">
                <div className="no-rec mt20">No records available</div>
                {reqDet?.inpatientNotes?.filter(
                  (li) =>
                    li?.appointmentId === reqDet?.appointment?.appointmentId &&
                    li?.type === "inpatient" &&
                    !li?.consolidated,
                )?.length > 1 &&
                reqDet?.inpatientNotes?.filter(
                  (li) =>
                    li?.appointmentId === reqDet?.appointment?.appointmentId &&
                    li?.type === "inpatient" &&
                    li?.consolidated,
                )?.length === 0 ? (
                  <div className="mv20">
                    <CustomButton
                      text="Consolidate Daily SOAP"
                      onClick={() => onConsolidateSoap("inpatient")}
                      smallBtn
                    />
                  </div>
                ) : null}
              </div>
            )} */}
            {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen pos-rel mt15">
                <Typography className="font-bold flex1-center fs14">
                  Red Flags
                </Typography>
                <Typography
                  className="blue-color fs12 txt-semi-bold underline cursor pos-absolute r0"
                  onClick={onViewRedFlagUpdates}
                >
                  View Updates
                </Typography>
              </div>
            </Grid>
            {(inpatientAlerts ?? [])?.map((alrt) => {
              return (
                <div className="red-con w100Per mt15" key={alrt?.alertId}>
                  <div className="flex-row">
                    <div className="w95Per">
                      <Typography className="black28 fs12 txt-regular">
                        {alrt?.text}
                      </Typography>
                    </div>
                    <div className="w5Per flex1-end">
                      <img
                        src={require("../../../../assets/images/png/edit-new.png")}
                        alt=""
                        className="img-wh20 cursor"
                        onClick={() => handleAddUpdateRedAlert(alrt)}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
            <div
              className="flex-row-ali-cen cursor mt20"
              onClick={() => handleAddUpdateRedAlert(null)}
            >
              <div className="flex-center plus-icon">
                <AddIcon sx={addIcon} />
              </div>
              <Typography className="blue-color fs16 ml5 font-bold">
                Add
              </Typography>
            </div> */}
            <div className="w100Per">
              <Instructions />
            </div>
            <div className="w100Per">
              <OverviewDiagnostics />
            </div>
          </>
        ) : null}
      </Grid>

      {followUpModVsble || isEditAppointment ? (
        <BookAnAppointment
          modalVisible={followUpModVsble || isEditAppointment}
          setBookModVisible={onCloseFollowUpMod}
          selectedPet={{
            petId: appDet?.petId,
            petName: appDet?.petName,
            petImage: appDet?.petImage,
            gender: appDet?.gender,
            breed: appDet?.breed,
            dob: appDet?.dob,
            userName: appDet?.userName,
            color: appDet?.color,
            weight: appDet?.weight,
            userMobile: appDet?.userMobile,
            mobile: appDet?.mobile,
          }}
          prevAppointmentId={appDet?.appointmentId}
          isEditAppointment={isEditAppointment}
          appointment={appDet}
          onBookModalCompleted={(e) => {
            if (e === "Api Success" && appDet?.appointmentId) {
              dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
            }
          }}
        />
      ) : null}

      {remarksModVsble ? (
        <UpdateRemarks
          remarksModVsble={remarksModVsble}
          onCloseRemarks={onCloseRemarks}
          remarks={appDet?.remarks}
          notes={reqDet?.notes}
          id={appDet?.appointmentId}
          facilityId={appDet?.facilityId}
          facility={appDet?.facility}
        />
      ) : null}

      <CustomModal
        open={bundleModVsble}
        onClose={handleBundleclose}
        header="Select Bundle"
        modal
        modalWidth={40}
      >
        <div className="scroll-60vh pr10">
          <CustomTextField
            placeholder="Search"
            fullWidth
            handleChange={(e) => setBundleSearchValue(e.target.value)}
            value={bundleSearchValue}
            backgroundColor={AppColors.lightPink}
          />

          {petTreatmentBundles?.length > 0 ? (
            (bundleSearchValue?.length > 0
              ? petTreatmentBundles?.filter((bl) =>
                  bl?.bundleName
                    ?.toLowerCase()
                    ?.includes(bundleSearchValue?.toLowerCase()),
                )
              : petTreatmentBundles
            )?.map((li, i) => {
              return (
                <div
                  key={i}
                  className={`mt15 cursor ${
                    li?.bundleId === selectedBundle?.bundleId
                      ? "blue-box2"
                      : "gray-box3"
                  }`}
                  onClick={() => setSelectedBundle(li)}
                >
                  <div className="flex-row-between-align-center">
                    <div className="flex-row-ali-cen">
                      <CustomCheckbox
                        circle
                        checked={
                          selectedBundle
                            ? li?.bundleId === selectedBundle?.bundleId
                            : false
                        }
                      />
                      <Typography className="fs14 blue-color font-bold">
                        {li?.bundleName}
                      </Typography>
                    </div>
                    <Typography className="font-bold fs14 red12">
                      Rs {Number(li?.estimatedCost)?.toFixed(2)}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen ph10">
                    <div className="gry-dot2" />
                    <Typography className="fs12 blue-color txt-regular ml5">
                      Type:
                    </Typography>
                    <Typography className="fs12 black20 txt-regular ml5">
                      {li?.usageType}
                    </Typography>
                  </div>

                  <Typography className="gray22 fs14 font-medium ph10">
                    {li?.description}
                  </Typography>
                </div>
              );
            })
          ) : (
            <div className="no-record">No active bundles available</div>
          )}
          {selectedBundle ? (
            <div className="flex-center">
              <div className="mv20">
                <CustomButton smallBtn text="Assign" onClick={handleAssign} />
              </div>
            </div>
          ) : null}
        </div>
      </CustomModal>

      <CustomModal
        open={cancelModVsble}
        onClose={onCancelModClose}
        header="Cancel"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to cancel the appointment?
        </Typography>
        <div className="ml10 mt15">
          <CustomTextField
            label="Reason for cancellation"
            placeholder="Enter reason for cancellation (optional)"
            multiline
            rows={4}
            value={cancelReason}
            handleChange={(e) => setCancelReason(e.target.value)}
            fullWidth
          />
        </div>
        <div className="flex-center">
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfirmCancel}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="No"
                onClick={() => {
                  onCancelModClose();
                  setCancelReason("");
                }}
                smallBtn
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={noShowModVsble}
        onClose={onCloseNoShowMod}
        header="No Show"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to mark the appointment as no-show?
        </Typography>

        <div className="flex-center">
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfirmNoShow}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseNoShowMod} smallBtn />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={reModVsble}
        onClose={onReModClose}
        header="Reschedule / Reassign"
        rightModal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20 scroll-80vh">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Card sx={cardSty} className="CustomCard-back-appointment">
              <div className="maint">
                <div className="flex-row">
                  <Grid item xs={3}>
                    <div className="flex-center">
                      {appDet?.petImage ? (
                        <CardMedia
                          image={appDet?.petImage}
                          className="CustomCard-img3-bill"
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {appDet?.petName?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Grid>
                  <div className="flex-row">
                    <div className="flex-start">
                      <div className="flex-column">
                        <div className="flex-row">
                          <div className="mb10 txt-semi-bold black fs14 capitalize">
                            {appDet?.petName}
                          </div>
                          <Typography
                            className={`ml5 text capitalize ${
                              appDet?.gender === "male"
                                ? "card-blue-color"
                                : "card-rose-color"
                            }`}
                          >
                            {`(${appDet?.gender})`}
                          </Typography>
                        </div>
                        <Typography className="mb10 txt-regular card-gray-color fs12">
                          {appDet?.breed}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex-row parentcontainer mt10">
                    <div className="flex-row iconcontainer">
                      <AccountCircleOutlinedIcon
                        sx={{ width: 25, height: 25 }}
                      />
                      <div className="txt-semi-bold fs14 capitalize">
                        {appDet?.userName}
                      </div>
                    </div>
                    <div className="meeting-doctor">
                      {moment(appDet?.appointmentDate).fromNow()} (
                      {appDet?.appointmentDate})
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Booking Type <span className="red-color">*</span>
            </div>
            <Select value={modValues?.bookingType} selectFixed />
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="txt-semi-bold fs14 light-grey">
              Consultation Mode <span className="red-color">*</span>
            </div>
            <Select value={appDet?.appointmentType} selectFixed />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Service Type <span className="red-color">*</span>
            </div>
            <Select value={appDet?.serviceType} selectFixed />
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-semi-bold fs14 light-grey">
              Reason for visit <span className="red-color">*</span>
            </div>
            <Select value={appDet?.reason} selectFixed />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Select
              list={vets}
              handleChange={(e, value) => onChangeValue("vetName", value)}
              name="vetName"
              search
              value={modValues?.vetName}
              error={!!errors?.vetName}
              helperText={errors?.vetName}
              label="Vet Name *"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Select
              list={vets}
              handleChange={(e) =>
                onChangeValue("assignedUsers", e?.target?.value)
              }
              name="assignedUsers"
              value={modValues?.assignedUsers ?? []}
              error={!!errors?.assignedUsers}
              helperText={errors?.assignedUsers}
              label="Assigned Users"
              multiSelectSearchCheck
            />
          </Grid>
          {appDet?.appointmentStatus?.toLowerCase() === "scheduled" && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Appointment Time:{" "}
                {moment(new Date(appDet?.appointmentdateTime)).format(
                  "DD MMM YYYY HH:mm",
                )}
              </div>
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="mbminus"
          >
            <div className="flex-row">
              <div className="txt-semi-bold fs14 light-grey mt10">
                Appointment <span className="red-color">*</span> :
              </div>
              <div className="ml5">
                <CustomCheckbox
                  radio
                  value={modValues?.appointmentOption}
                  onChange={(e) =>
                    onChangeValue("appointmentOption", e?.target?.value)
                  }
                  radios={
                    appDet?.appointmentStatus?.toLowerCase() !== "scheduled"
                      ? appointmentList
                      : appointmentLaterList
                  }
                  disabled={
                    appDet?.appointmentStatus?.toLowerCase() !== "scheduled"
                  }
                  defaultValue={modValues?.appointmentOption}
                />
              </div>
            </div>

            {!!errors?.appointmentOption && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography color="error" className="mt5 fs14">
                  Appointment is Required
                </Typography>
              </Grid>
            )}
          </Grid>

          {appDet?.appointmentStatus?.toLowerCase() === "scheduled" &&
            modValues?.appointmentOption === "Later" && (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="txt-mont fs14 ">
                  Date <span className="red-color">*</span>
                </div>
                <div className="mb20">
                  <CustomTextField
                    name="date"
                    value={modValues?.date}
                    labelTop
                    fullWidth
                    handleChange={(e) =>
                      onChangeValue("date", e?.target?.value)
                    }
                    mobileDateWithBatch
                    // markDateList={holidayDates ?? []}
                  />
                </div>
              </Grid>
            )}

          {appDet?.appointmentStatus?.toLowerCase() === "scheduled" &&
            modValues?.appointmentOption === "Later" &&
            modValues?.date &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: modValues?.date,
              bookedApnts: vetBookedApnts,
              holidays,
            })?.length > 0 &&
            getRequiredSlotList({
              availability: vetAvailability,
              date: modValues?.date,
              bookedApnts: vetBookedApnts,
              holidays,
            })?.map((item, i) => {
              return (
                <div
                  key={i}
                  onClick={() => handleSelectTime(item)}
                  className={
                    selectTime === item?.startTime
                      ? "bgContainerSelected cursor"
                      : "bgContainerUnselected cursor"
                  }
                >
                  {item?.startTime}
                </div>
              );
            })}

          {selectTimeIdError && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography color="error" className="mt5 fs14">
                Time is Requried
              </Typography>
            </Grid>
          )}
          <div className="flex1-end mt20">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <CustomButton text="Save" onClick={onSaveRe} smallBtn />
            </Grid>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={movPatModVsble}
        onClose={onCloseModPatMod}
        header="Move Patient"
        modal
        modalWidth={30}
        headerBold
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row-ali-cen">
              <div className="w25Per">
                <Typography className="txt-semi-bold gray7 fs14">
                  Move To
                </Typography>
              </div>
              <div className="w75Per">
                <Select
                  list={movePatientList}
                  handleChange={(e) =>
                    onChangeMovePat("moveTo", e?.target?.value)
                  }
                  name="moveTo"
                  select
                  value={modValues?.moveTo}
                  label=""
                />
              </div>
            </div>
          </Grid>
          <div className="flex1-end mt20 mb10">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <CustomButton text="Submit" onClick={onMovePatient} smallBtn />
            </Grid>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={redAlertModVsble}
        onClose={onCloseRedAlertMod}
        header="Red Flag"
        modal
        modalWidth={40}
        headerBold
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomTextField
              name="alert"
              fullWidth
              handleChange={(e) =>
                setModValues({ ...modValues, alert: e?.target?.value })
              }
              value={modValues?.alert}
              multiline
            />
          </Grid>
          <div className="flex1-end mt20 mb10">
            <div>
              <CustomButton text="Submit" onClick={onSaveRedAlert} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>

      <CustomModal
        open={redFlagUpdatesVsble}
        onClose={() => setRedFlagUpdatesVsble(false)}
        header="Red Flags"
        modal
        modalWidth={40}
        headerCenter
      >
        <div className="scroll-50vh">
          {reqDet?.inpatientNotes?.filter(
            (li) =>
              li?.appointmentId === reqDet?.appointment?.appointmentId &&
              li?.type?.toLowerCase() === "inpatient" &&
              li?.redFlags?.length > 0,
          )?.length > 0 ? (
            <div className="timeline-container">
              <div className="timeline-line" />
              <div className="tasks-container">
                {reqDet?.inpatientNotes
                  ?.filter(
                    (li) =>
                      li?.appointmentId ===
                        reqDet?.appointment?.appointmentId &&
                      li?.type?.toLowerCase() === "inpatient" &&
                      li?.redFlags?.length > 0,
                  )
                  ?.map((li) => (
                    <div key={li?.noteId}>
                      <div className="flex-row mv10">
                        <div className="tsk-gry-dot" />
                        <div className="gray37 fs12 txt-semi-bold con-fit ml20 tsk-gry-time">
                          {moment(li?.createdDate).format("DD MMM YYYY, HH:mm")}
                        </div>
                      </div>
                      <Typography className="ml20 txt-semi-bold fs14 black7 mt10">
                        {li?.redFlags}
                      </Typography>
                      <Typography className="ml20 font-medium fs12 gray11 mt5">
                        {li?.userName}
                      </Typography>
                    </div>
                  ))}
              </div>
            </div>
          ) : (
            <div className="no-rec">No records available</div>
          )}
        </div>
      </CustomModal>

      <CustomModal
        open={dailyUpdatesVsble}
        onClose={() => setDailyUpdatesVsble(false)}
        header="Daily Updates"
        modal
        modalWidth={80}
        headerCenter
      >
        <div className="scroll-60vh">
          {reqDet?.inpatientNotes
            ?.filter(
              (li) =>
                li?.appointmentId === reqDet?.appointment?.appointmentId &&
                li?.type?.toLowerCase() === "inpatient" &&
                li?.consolidated === true,
            )
            ?.map((li, i) => {
              return (
                <div key={li?.noteId} className="mv10">
                  <Typography className="txt-semi-bold fs14 blue-color mt10">
                    Note {i + 1}
                  </Typography>
                  {inpatientList?.map((lii) => {
                    return (
                      <div>
                        <div className="heading-fw600 fs14 black mt5">
                          {nameExten?.[lii]}
                        </div>
                        <Typography className="font-medium fs14 gray9">
                          {li?.[lii?.charAt(0)?.toLowerCase() + lii?.slice(1)]}
                        </Typography>
                      </div>
                    );
                  })}
                  <div className="flex-center mv10">
                    <div>
                      <CustomButton
                        text="Reviewed"
                        smallBtn
                        onClick={() => onUpdateReviewed(li)}
                        disabled={li?.reviewed}
                        grayBtn={li?.reviewed}
                      />
                    </div>
                  </div>
                  <Divider className="mv10" />
                </div>
              );
            })}
        </div>
      </CustomModal>

      <CustomModal
        open={assignUsersModVsble}
        onClose={onCloseAssignUsersMod}
        header="Assign Users"
        modalWidth={30}
        modal
      >
        <Grid container spacing={2} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Select
              list={getAllClinicUserListWoSelectedVet(appDet?.doctorId)}
              value={modValues?.assignedUsers ?? []}
              name="assignedUsers"
              handleChange={(e) => {
                onChangeValue("assignedUsers", e?.target?.value);
              }}
              label="Assigned Users"
              multiSelectSearchCheck
            />
          </Grid>
          <div className="flex1-center mv20">
            <div>
              <CustomButton
                text="Update"
                onClick={onUpdateAssignedUsers}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Overview;
